import { Checkbox } from "@aqar-app/react-ui";
import React, { useEffect, useRef, useState } from "react";
import { dispatchCtxChange } from "@/components/add-v2/ui";
import {
  getDynamicLabel,
  useRevalidateAndCalculations,
} from "@/components/add-v2/validate";
import css from "./.module.scss";

export function CheckboxComponent({
  nested,
  label,
  value: initialValue,
  defaultValue,
  switch: s,
  name,
  calculations,
  dependencies,
  rules,
  ctxRef,
  dynamicProps,
  visibilityRules,
  ...props
}) {
  const [value, setValue] = useState(initialValue || defaultValue);
  const text = label?.dynamic
    ? getDynamicLabel({ label, ctx: ctxRef.current })
    : label?.ar;
  const rootRef = useRef(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    const root = rootRef.current;
    if (!root) return;
    root.addEventListener("validate", (e) => {
      setError(e?.detail?.error);
    });
  }, []);

  return (
    <div ref={rootRef}>
      <Checkbox
        {...props}
        name={name}
        switch={s}
        checked={!!value}
        onChange={(e) => {
          setValue(e.target.checked);
          dispatchCtxChange(e.target, {
            value: e.target.checked,
            name,
            nested,
          });
        }}
      >
        {text || name}
      </Checkbox>
      <p className={css.error}>{error}</p>
    </div>
  );
}
